import { createFileRoute } from '@tanstack/react-router';

import { Costume } from '@/view/pages/Decoupages/Costume';

export const Route = createFileRoute('/_protected/$programId/decupagens/figurino')({
  component: Costume,
  context: (context): { title: string } => ({
    ...context,
    title: 'Decupagem de Figurino',
  }),
});
